import axios from "axios";
import { encode as base64_encode } from "base-64";
import React from "react";
import MaterialIcon from "material-icons-react";
import HeaderPage from "../../components/PageHeader/PageHeader";
import StepCounter from "../../components/StepCounter/StepCounter";
import Loader from "../../components/Loader/Loader";
import { retornarCookie } from "../../services/cookieservice";
import {
  obterConfiguracaoNivel2,
  listarPatologiasCRM,
  listarPatologiasOportunidade,
  adicionarPatologia,
  removerPatologia,
  listarInativos,
  adicionarInativo,
  removerInativo as removerInativoApi,
  listarAgregados,
  adicionarAgregado,
  removerAgregado as removerAgregadoApi,
  listarArquivos,
  uploadArquivo,
  removerArquivo,
  atualizarOportunidadeNivel2,
} from "../../services/nivel2service";
import "../../index.css";
import "./InformacoesNivel2Page.css";

const { REACT_APP_API, REACT_APP_URL_INSTANCE } = process.env;

export default class InformacoesNivel2Page extends React.Component {
  fileInputRef = React.createRef();
  patologiaFileInputRefs = {};

  tiposDocumentoArquivo = [
    { value: "RelatorioMedico", label: "Relatório Médico" },
  ];

  state = {
    oportunidade: undefined,
    configuracao: undefined,
    exibeCarregamento: true,

    QtdeVidasCLT: 0,
    QtdeVidasPSPJ: 0,
    QtdeVidasSocios: 0,
    erroDistribuicao: "",

    possuiPatologias: false,
    listaPatologiasCRM: [],
    listaPatologiasRegistradas: [],
    novaPatologiaId: "",
    novaPatologiaQtdeVidas: 0,
    erroPatologia: "",

    possuiInativos: false,
    listaElegibilidades: [],
    listaInativos: [],
    novoInativoTipoArtigo: "Art30",
    novoInativoDataNascimento: "",
    novoInativoDataDesligamento: "",
    novoInativoElegibilidadeId: "",
    erroInativo: "",

    possuiAgregados: false,
    listaAgregados: [],
    listaTiposVinculoAgregado: [],
    novoAgregadoTipoVinculo: "Conjuge",
    novoAgregadoDataNascimento: "",
    novoAgregadoElegibilidadeId: "",
    erroAgregado: "",

    reembolsoDiferenciado: false,

    listaArquivos: [],
    erroArquivo: "",
  };

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const oportunidadeId = urlParams.get("OportunidadeID");
    this.carregarDados(oportunidadeId);
  }

  carregarDados = async (oportunidadeId) => {
    this.setState({ exibeCarregamento: true });

    const paramsOportunidade = {
      oportunidadeID: oportunidadeId,
      IdAgenteVendas: retornarCookie("IdAgenteVenda"),
      CdAgenteVendas: retornarCookie("CdAgenteVendas"),
      multiplasPropostas: false,
    };

    try {
      const [
        oportunidadeRes,
        configuracao,
        patologiasCRM,
        patologiasRegistradas,
        inativos,
        agregados,
        arquivos,
      ] = await Promise.all([
        axios.get(`${REACT_APP_API}oportunidade/OportunidadePorId`, {
          params: paramsOportunidade,
        }),
        obterConfiguracaoNivel2(),
        listarPatologiasCRM(),
        listarPatologiasOportunidade(oportunidadeId),
        listarInativos(oportunidadeId),
        listarAgregados(oportunidadeId),
        listarArquivos(oportunidadeId),
      ]);

      const oportunidade = oportunidadeRes.data;

      this.setState(
        {
          oportunidade,
          configuracao,
          listaPatologiasCRM: patologiasCRM || [],
          listaPatologiasRegistradas: patologiasRegistradas || [],
          listaInativos: inativos || [],
          listaAgregados: agregados || [],
          listaTiposVinculoAgregado: configuracao?.TiposVinculoAgregado || [],
          listaArquivos: arquivos || [],
          QtdeVidasCLT: oportunidade?.QtdeVidasCLT ?? oportunidade?.QtdVidasCLT ?? 0,
          QtdeVidasPSPJ: oportunidade?.QtdeVidasPSPJ ?? oportunidade?.QtdVidasPSPJ ?? 0,
          QtdeVidasSocios: oportunidade?.QtdeVidasSocios ?? oportunidade?.QtdVidasSocios ?? 0,
          possuiPatologias:
            Boolean(oportunidade?.PossuiPatologias) || Boolean((patologiasRegistradas || []).length),
          possuiInativos:
            Boolean(oportunidade?.PossuiInativos) || Boolean((inativos || []).length),
          possuiAgregados:
            Boolean(oportunidade?.PossuiAgregados) || Boolean((agregados || []).length),
          reembolsoDiferenciado:
            oportunidade?.ReembolsoDiferenciado ?? oportunidade?.reembolsoDiferenciado ?? false,
        },
        this.validarDistribuicao
      );
    } catch (error) {
      alert("Erro ao carregar informações do Nível 2.");
    } finally {
      this.setState({ exibeCarregamento: false });
    }
  };

  getOportunidadeId = () => {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("OportunidadeID");
  };

  getStepTotal = () => {
    const isFilial3 = retornarCookie("Filial") === "3";
    const isReembolso = this.state.reembolsoDiferenciado === true;

    if (isFilial3) {
      return 5;
    }

    return isReembolso ? 6 : 5;
  };

  normalizarQuantidadeDistribuicao = (valor, limiteMaximo) => {
    const numero = parseInt((valor || 0).toString().replace(/\D/g, ""), 10);
    if (Number.isNaN(numero)) {
      return 0;
    }

    if (numero < 0) {
      return 0;
    }

    if (numero > limiteMaximo) {
      return limiteMaximo;
    }

    return numero;
  };

  handleChangeDistribuicao = (event) => {
    const { name, value } = event.target;
    const { oportunidade, QtdeVidasCLT, QtdeVidasPSPJ, QtdeVidasSocios } = this.state;
    const totalTit = oportunidade?.QtdeVidasTit || 0;

    const outros = {
      QtdeVidasCLT,
      QtdeVidasPSPJ,
      QtdeVidasSocios,
    };
    delete outros[name];

    const somaOutros = Object.values(outros).reduce((acc, curr) => acc + (parseInt(curr, 10) || 0), 0);
    const maximoParaCampo = Math.max(totalTit - somaOutros, 0);
    const numeroNormalizado = this.normalizarQuantidadeDistribuicao(value, maximoParaCampo);

    this.setState(
      {
        [name]: numeroNormalizado,
      },
      this.validarDistribuicao
    );
  };

  validarDistribuicao = () => {
    const { QtdeVidasCLT, QtdeVidasPSPJ, QtdeVidasSocios, oportunidade, configuracao } =
      this.state;

    const totalTit = oportunidade?.QtdeVidasTit || 0;

    if (!totalTit) {
      this.setState({ erroDistribuicao: "" });
      return;
    }

    const soma = QtdeVidasCLT + QtdeVidasPSPJ + QtdeVidasSocios;

    if (soma !== totalTit) {
      this.setState({
        erroDistribuicao: `A soma dos vínculos deve ser igual a ${totalTit} vidas.`,
      });
      return;
    }

    const percPSPJ = (QtdeVidasPSPJ / totalTit) * 100;
    const percSocios = (QtdeVidasSocios / totalTit) * 100;

    if (percPSPJ > (configuracao?.PercentualMaxPSPJ || 0)) {
      this.setState({
        erroDistribuicao: `Proporção PSPJ excede ${configuracao?.PercentualMaxPSPJ}% - cotação será enviada para análise (Nível 3).`,
      });
      return;
    }

    if (percSocios > (configuracao?.PercentualMaxSocios || 0)) {
      this.setState({
        erroDistribuicao: `Proporção de Sócios excede ${configuracao?.PercentualMaxSocios}% - cotação será enviada para análise (Nível 3).`,
      });
      return;
    }

    this.setState({ erroDistribuicao: "" });
  };

  togglePossuiPatologias = async (event) => {
    const checked = event.target.checked;

    if (!checked && this.state.listaPatologiasRegistradas.length > 0) {
      const confirma = window.confirm("Remover todas as patologias cadastradas?");
      if (!confirma) {
        return;
      }

      await this.removerTodasPatologias();
    }

    this.setState({ possuiPatologias: checked });
  };

  removerTodasPatologias = async () => {
    const oportunidadeId = this.getOportunidadeId();
    const lista = [...this.state.listaPatologiasRegistradas];

    for (let i = 0; i < lista.length; i += 1) {
      // eslint-disable-next-line no-await-in-loop
      await removerPatologia(oportunidadeId, lista[i].Id || lista[i].id);
    }

    this.setState({ listaPatologiasRegistradas: [] });
  };

  getTotalVidasPatologias = (lista = this.state.listaPatologiasRegistradas) =>
    (lista || []).reduce(
      (acc, item) => acc + (parseInt(item?.QtdeVidas ?? item?.qtdeVidas ?? 0, 10) || 0),
      0
    );

  getLimiteVidasPatologias = () => {
    const { oportunidade } = this.state;
    return parseInt(oportunidade?.QtdeVidas ?? oportunidade?.qtdeVidas ?? oportunidade?.QtdeVidasTit ?? 0, 10) || 0;
  };

  adicionarNovaPatologia = async () => {
    const { novaPatologiaId, novaPatologiaQtdeVidas } = this.state;
    const oportunidadeId = this.getOportunidadeId();
    const qtdeNovaPatologia = parseInt(novaPatologiaQtdeVidas, 10);

    if (!novaPatologiaId || qtdeNovaPatologia <= 0) {
      this.setState({ erroPatologia: "Selecione a patologia e informe a quantidade." });
      return;
    }

    const totalPatologiasAtual = this.getTotalVidasPatologias();
    const limiteVidasPatologias = this.getLimiteVidasPatologias();
    if (totalPatologiasAtual + qtdeNovaPatologia > limiteVidasPatologias) {
      this.setState({
        erroPatologia:
          `A soma de vidas em patologias não pode ultrapassar ${limiteVidasPatologias}. Atual: ${totalPatologiasAtual}.`,
      });
      return;
    }

    this.setState({ exibeCarregamento: true });

    try {
      await adicionarPatologia(oportunidadeId, {
        PatologiaId: novaPatologiaId,
        QtdeVidas: qtdeNovaPatologia,
      });

      const listaPatologiasRegistradas = await listarPatologiasOportunidade(oportunidadeId);
      this.setState({
        listaPatologiasRegistradas,
        novaPatologiaId: "",
        novaPatologiaQtdeVidas: 0,
        erroPatologia: "",
        possuiPatologias: true,
      });
    } catch (error) {
      this.setState({ erroPatologia: "Não foi possível adicionar a patologia." });
    } finally {
      this.setState({ exibeCarregamento: false });
    }
  };

  removerPatologiaRegistrada = async (id) => {
    if (!window.confirm("Remover patologia?")) {
      return;
    }

    this.setState({ exibeCarregamento: true });

    try {
      const oportunidadeId = this.getOportunidadeId();
      await removerPatologia(oportunidadeId, id);
      const listaPatologiasRegistradas = await listarPatologiasOportunidade(oportunidadeId);
      this.setState({ listaPatologiasRegistradas });
    } catch (error) {
      alert("Erro ao remover patologia.");
    } finally {
      this.setState({ exibeCarregamento: false });
    }
  };

  togglePossuiInativos = async (event) => {
    const checked = event.target.checked;

    if (!checked && this.state.listaInativos.length > 0) {
      const confirma = window.confirm("Remover todos os inativos cadastrados?");
      if (!confirma) {
        return;
      }

      const oportunidadeId = this.getOportunidadeId();
      const lista = [...this.state.listaInativos];

      for (let i = 0; i < lista.length; i += 1) {
        // eslint-disable-next-line no-await-in-loop
        await removerInativoApi(oportunidadeId, lista[i].Id || lista[i].id);
      }

      this.setState({ listaInativos: [] });
    }

    this.setState({ possuiInativos: checked });
  };

  normalizarDataParaISO = (valor) => {
    const texto = (valor || "").toString().trim();
    if (!texto) {
      return "";
    }

    let ano = "";
    let mes = "";
    let dia = "";

    const matchIso = texto.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s].*)?$/);
    if (matchIso) {
      [, ano, mes, dia] = matchIso;
    } else {
      const matchBr = texto.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (!matchBr) {
        return "";
      }

      [, dia, mes, ano] = matchBr;
    }

    if (!this.isDataCalendarioValida(ano, mes, dia)) {
      return "";
    }

    return `${ano}-${mes}-${dia}`;
  };

  isDataCalendarioValida = (ano, mes, dia) => {
    const anoNum = parseInt(ano, 10);
    const mesNum = parseInt(mes, 10);
    const diaNum = parseInt(dia, 10);

    if (
      Number.isNaN(anoNum) ||
      Number.isNaN(mesNum) ||
      Number.isNaN(diaNum) ||
      mesNum < 1 ||
      mesNum > 12 ||
      diaNum < 1 ||
      diaNum > 31
    ) {
      return false;
    }

    const data = new Date(Date.UTC(anoNum, mesNum - 1, diaNum));
    return (
      data.getUTCFullYear() === anoNum &&
      data.getUTCMonth() === mesNum - 1 &&
      data.getUTCDate() === diaNum
    );
  };

  aplicarMascaraData = (valor) => {
    const numeros = (valor || "").toString().replace(/\D/g, "").slice(0, 8);

    if (numeros.length <= 2) {
      return numeros;
    }

    if (numeros.length <= 4) {
      return `${numeros.slice(0, 2)}/${numeros.slice(2)}`;
    }

    return `${numeros.slice(0, 2)}/${numeros.slice(2, 4)}/${numeros.slice(4)}`;
  };

  getErroDateFieldByStateKey = (stateKey) =>
    stateKey === "novoAgregadoDataNascimento" ? "erroAgregado" : "erroInativo";

  isDataBrParcialValida = (valor) => {
    const texto = (valor || "").toString();
    if (!texto) {
      return true;
    }

    const partes = texto.split("/");
    const dia = partes[0] || "";
    const mes = partes[1] || "";
    const ano = partes[2] || "";

    if (dia.length === 2) {
      const diaNum = parseInt(dia, 10);
      if (Number.isNaN(diaNum) || diaNum < 1 || diaNum > 31) {
        return false;
      }
    }

    if (mes.length === 2) {
      const mesNum = parseInt(mes, 10);
      if (Number.isNaN(mesNum) || mesNum < 1 || mesNum > 12) {
        return false;
      }
    }

    if (ano.length === 4 && dia.length === 2 && mes.length === 2) {
      return this.isDataCalendarioValida(ano, mes, dia);
    }

    return true;
  };

  handleChangeData = (stateKey) => (event) => {
    const valorMascarado = this.aplicarMascaraData(event.target.value);
    const erroKey = this.getErroDateFieldByStateKey(stateKey);

    if (!this.isDataBrParcialValida(valorMascarado)) {
      this.setState({
        [erroKey]: "Data inválida. Use o formato dd/mm/aaaa com dia e mês válidos.",
      });
      return;
    }

    const novoEstado = { [stateKey]: valorMascarado };
    if (valorMascarado.length === 10) {
      const dataIso = this.normalizarDataParaISO(valorMascarado);
      if (!dataIso) {
        this.setState({
          [erroKey]: "Data inválida. Use o formato dd/mm/aaaa com dia e mês válidos.",
        });
        return;
      }

      novoEstado[erroKey] = "";
    }

    this.setState(novoEstado);
  };

  handleBlurData = (stateKey) => () => {
    const valorAtual = (this.state[stateKey] || "").toString().trim();
    const erroKey = this.getErroDateFieldByStateKey(stateKey);

    if (!valorAtual) {
      this.setState({ [stateKey]: "", [erroKey]: "" });
      return;
    }

    const dataIso = this.normalizarDataParaISO(valorAtual);
    if (valorAtual.length !== 10 || !dataIso) {
      this.setState({ [stateKey]: "", [erroKey]: "" });
      return;
    }

    this.setState({ [stateKey]: this.formatarDataParaInput(dataIso), [erroKey]: "" });
  };

  formatarDataParaInput = (valor) => {
    const iso = this.normalizarDataParaISO(valor);
    if (!iso) {
      return valor || "";
    }

    const [ano, mes, dia] = iso.split("-");
    return `${dia}/${mes}/${ano}`;
  };

  formatarDataTabela = (valor) => {
    const iso = this.normalizarDataParaISO(valor);
    if (!iso) {
      return "";
    }

    const [ano, mes, dia] = iso.split("-");
    return `${dia}/${mes}/${ano}`;
  };

  calcularIdade = (dataNascimento) => {
    const nascimento = new Date(this.normalizarDataParaISO(dataNascimento));
    const hoje = new Date();

    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const mes = hoje.getMonth() - nascimento.getMonth();

    if (mes < 0 || (mes === 0 && hoje.getDate() < nascimento.getDate())) {
      idade -= 1;
    }

    return idade;
  };

  calcularMesesInatividade = (dataDesligamento) => {
    const deslig = new Date(this.normalizarDataParaISO(dataDesligamento));
    const hoje = new Date();

    return (
      (hoje.getFullYear() - deslig.getFullYear()) * 12 +
      (hoje.getMonth() - deslig.getMonth())
    );
  };

  adicionarNovoInativo = async () => {
    const {
      novoInativoTipoArtigo,
      novoInativoDataNascimento,
      novoInativoDataDesligamento,
      novoInativoElegibilidadeId,
      configuracao,
    } = this.state;

    const dataNascimentoISO = this.normalizarDataParaISO(novoInativoDataNascimento);
    const dataDesligamentoISO = this.normalizarDataParaISO(novoInativoDataDesligamento);

    if (novoInativoDataNascimento && !dataNascimentoISO) {
      this.setState({ erroInativo: "Data de nascimento inválida. Use dd/mm/aaaa." });
      return;
    }

    if (novoInativoDataDesligamento && !dataDesligamentoISO) {
      this.setState({ erroInativo: "Data de desligamento inválida. Use dd/mm/aaaa." });
      return;
    }

    if (
      !novoInativoTipoArtigo ||
      !dataNascimentoISO ||
      !dataDesligamentoISO ||
      !novoInativoElegibilidadeId
    ) {
      this.setState({ erroInativo: "Preencha os campos obrigatórios do inativo (dd/mm/aaaa)." });
      return;
    }

    const idade = this.calcularIdade(dataNascimentoISO);
    if (idade > (configuracao?.IdadeMaximaInativo || 0)) {
      this.setState({
        erroInativo: `Idade do inativo excede o máximo de ${configuracao?.IdadeMaximaInativo} anos.`,
      });
      return;
    }

    const meses = this.calcularMesesInatividade(dataDesligamentoISO);
    if (
      novoInativoTipoArtigo === "Art30" &&
      meses > (configuracao?.TempoMaxInatividadeArt30 || 0)
    ) {
      this.setState({ erroInativo: "Tempo máximo de inatividade Art 30 excedido." });
      return;
    }

    if (
      novoInativoTipoArtigo === "Art31" &&
      meses > (configuracao?.TempoMaxInatividadeArt31 || 999)
    ) {
      this.setState({ erroInativo: "Tempo máximo de inatividade Art 31 excedido." });
      return;
    }

    this.setState({ exibeCarregamento: true });

    try {
      const oportunidadeId = this.getOportunidadeId();
      await adicionarInativo({
        OportunidadeId: parseInt(oportunidadeId, 10),
        ElegibilidadeId: parseInt(novoInativoElegibilidadeId, 10),
        TipoArtigo: novoInativoTipoArtigo,
        DataNascimento: `${dataNascimentoISO}T00:00:00`,
        DataDesligamento: `${dataDesligamentoISO}T00:00:00`,
      });

      const listaInativos = await listarInativos(oportunidadeId);
      this.setState({
        listaInativos,
        novoInativoDataNascimento: "",
        novoInativoDataDesligamento: "",
        novoInativoElegibilidadeId: "",
        erroInativo: "",
        possuiInativos: true,
      });
    } catch (error) {
      this.setState({ erroInativo: "Não foi possível adicionar o inativo." });
    } finally {
      this.setState({ exibeCarregamento: false });
    }
  };

  removerInativo = async (id) => {
    if (!window.confirm("Remover inativo?")) {
      return;
    }

    this.setState({ exibeCarregamento: true });

    try {
      const oportunidadeId = this.getOportunidadeId();
      await removerInativoApi(oportunidadeId, id);
      const listaInativos = await listarInativos(oportunidadeId);
      this.setState({ listaInativos });
    } catch (error) {
      alert("Erro ao remover inativo.");
    } finally {
      this.setState({ exibeCarregamento: false });
    }
  };

  togglePossuiAgregados = async (event) => {
    const checked = event.target.checked;

    if (!checked && this.state.listaAgregados.length > 0) {
      const confirma = window.confirm("Remover todos os agregados cadastrados?");
      if (!confirma) {
        return;
      }

      const oportunidadeId = this.getOportunidadeId();
      const lista = [...this.state.listaAgregados];

      for (let i = 0; i < lista.length; i += 1) {
        // eslint-disable-next-line no-await-in-loop
        await removerAgregadoApi(oportunidadeId, lista[i].Id || lista[i].id);
      }

      this.setState({ listaAgregados: [] });
    }

    this.setState({ possuiAgregados: checked });
  };

  adicionarNovoAgregado = async () => {
    const {
      novoAgregadoTipoVinculo,
      novoAgregadoDataNascimento,
      novoAgregadoElegibilidadeId,
      configuracao,
    } = this.state;

    const dataNascimentoISO = this.normalizarDataParaISO(novoAgregadoDataNascimento);

    if (novoAgregadoDataNascimento && !dataNascimentoISO) {
      this.setState({ erroAgregado: "Data de nascimento inválida. Use dd/mm/aaaa." });
      return;
    }

    if (!novoAgregadoTipoVinculo || !dataNascimentoISO || !novoAgregadoElegibilidadeId) {
      this.setState({ erroAgregado: "Preencha os campos obrigatórios do agregado (dd/mm/aaaa)." });
      return;
    }

    const idade = this.calcularIdade(dataNascimentoISO);
    const maxTitularAgregado = configuracao?.IdadeMaximaTitularAgregado || 0;
    const maxConjuge = configuracao?.IdadeMaximaConjuge || 0;
    const maxFilho = configuracao?.IdadeMaximaFilho || 0;

    if (
      (novoAgregadoTipoVinculo === "Titular" ||
        novoAgregadoTipoVinculo === "Agregado Titular") &&
      idade > maxTitularAgregado
    ) {
      this.setState({ erroAgregado: `Idade excede o máximo de ${maxTitularAgregado} anos.` });
      return;
    }

    if (novoAgregadoTipoVinculo === "Conjuge" && idade > maxConjuge) {
      this.setState({ erroAgregado: `Idade excede o máximo de ${maxConjuge} anos.` });
      return;
    }

    if (novoAgregadoTipoVinculo === "Filho" && idade > maxFilho) {
      this.setState({ erroAgregado: `Idade excede o máximo de ${maxFilho} anos.` });
      return;
    }

    this.setState({ exibeCarregamento: true });

    try {
      const oportunidadeId = this.getOportunidadeId();
      await adicionarAgregado({
        OportunidadeId: parseInt(oportunidadeId, 10),
        ElegibilidadeId: parseInt(novoAgregadoElegibilidadeId, 10),
        TipoVinculo: novoAgregadoTipoVinculo,
        DataNascimento: `${dataNascimentoISO}T00:00:00`,
      });

      const listaAgregados = await listarAgregados(oportunidadeId);
      this.setState({
        listaAgregados,
        novoAgregadoDataNascimento: "",
        novoAgregadoElegibilidadeId: "",
        erroAgregado: "",
        possuiAgregados: true,
      });
    } catch (error) {
      this.setState({ erroAgregado: "Não foi possível adicionar o agregado." });
    } finally {
      this.setState({ exibeCarregamento: false });
    }
  };

  removerAgregado = async (id) => {
    if (!window.confirm("Remover agregado?")) {
      return;
    }

    this.setState({ exibeCarregamento: true });

    try {
      const oportunidadeId = this.getOportunidadeId();
      await removerAgregadoApi(oportunidadeId, id);
      const listaAgregados = await listarAgregados(oportunidadeId);
      this.setState({ listaAgregados });
    } catch (error) {
      alert("Erro ao remover agregado.");
    } finally {
      this.setState({ exibeCarregamento: false });
    }
  };

  handleFileSelected = (event) => {
    const file = event.target.files && event.target.files[0];

    if (!file) {
      return;
    }

    const split = file.name.split(".");
    const extensao = split.length > 1 ? split.pop() : "";
    const nomeArquivoInferido = this.gerarNomeArquivoInferido(
      this.state.tipoDocumentoArquivo,
      this.getOportunidadeId()
    );

    const reader = new FileReader();

    reader.onload = (e) => {
      const result = e.target?.result || "";
      const base64 = result.toString().split(",").pop();

      this.setState({
        arquivoBase64: base64,
        arquivoNome: nomeArquivoInferido,
        arquivoExtensao: extensao,
      });
    };

    reader.readAsDataURL(file);
  };

  gerarNomeArquivoInferido = (tipoDocumento, oportunidadeId) => {
    const tipo = (tipoDocumento || "Documento")
      .replace(/([a-z])([A-Z])/g, "$1_$2")
      .replace(/[^a-zA-Z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "")
      .toUpperCase();

    const data = new Date();
    const pad = (valor) => valor.toString().padStart(2, "0");
    const timestamp = `${data.getFullYear()}${pad(data.getMonth() + 1)}${pad(
      data.getDate()
    )}_${pad(data.getHours())}${pad(data.getMinutes())}${pad(data.getSeconds())}`;

    return `${tipo}_OP${oportunidadeId || "0"}_${timestamp}`;
  };

  getPatologiaRegistroId = (patologia) => patologia?.Id || patologia?.id;

  getArquivosDaPatologia = (patologia) => {
    const patologiaId = this.getPatologiaRegistroId(patologia);
    const patologiaNome = (patologia?.PatologiaNome || patologia?.patologiaNome || "").toString().trim();

    return (this.state.listaArquivos || []).filter((arquivo) => {
      const arquivoPatologiaId = arquivo?.PatologiaId || arquivo?.patologiaId;
      if (arquivoPatologiaId !== undefined && arquivoPatologiaId !== null && patologiaId) {
        return String(arquivoPatologiaId) === String(patologiaId);
      }

      const arquivoPatologiaNome = (arquivo?.PatologiaNome || arquivo?.patologiaNome || "").toString().trim();
      return !!patologiaNome && arquivoPatologiaNome === patologiaNome;
    });
  };

  converterArquivoParaBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const result = e.target?.result || "";
        resolve(result.toString().split(",").pop() || "");
      };
      reader.onerror = () => reject(new Error("Falha ao ler arquivo"));
      reader.readAsDataURL(file);
    });

  abrirSeletorArquivosPatologia = (patologiaId) => {
    const input = this.patologiaFileInputRefs[String(patologiaId)];
    if (input) {
      input.click();
    }
  };

  enviarArquivosDaPatologia = async (patologia, fileList) => {
    const files = Array.from(fileList || []);
    if (!files.length) {
      return;
    }

    const patologiaId = this.getPatologiaRegistroId(patologia);
    if (!patologiaId) {
      this.setState({ erroArquivo: "Patologia inválida para upload." });
      return;
    }

    this.setState({ exibeCarregamento: true, erroArquivo: "" });

    try {
      const oportunidadeId = this.getOportunidadeId();

      for (let i = 0; i < files.length; i += 1) {
        const file = files[i];
        const split = file.name.split(".");
        const extensao = split.length > 1 ? split.pop() : "";
        // eslint-disable-next-line no-await-in-loop
        const conteudo = await this.converterArquivoParaBase64(file);
        const nomeArquivo = this.gerarNomeArquivoInferido("RelatorioMedico", oportunidadeId);

        // eslint-disable-next-line no-await-in-loop
        await uploadArquivo(oportunidadeId, {
          Conteudo: conteudo,
          NomeArquivo: nomeArquivo,
          ExtensaoArquivo: extensao,
          TipoArquivo: "RelatorioMedico",
          PatologiaId: parseInt(patologiaId, 10),
        });
      }

      const listaArquivos = await listarArquivos(oportunidadeId);
      this.setState({ listaArquivos, erroArquivo: "" });
    } catch (error) {
      const status = error?.response?.status;
      this.setState({
        erroArquivo: status
          ? `Não foi possível enviar os anexos da patologia. API retornou ${status}.`
          : "Não foi possível enviar os anexos da patologia.",
      });
    } finally {
      this.setState({ exibeCarregamento: false });
    }
  };

  handleChangeArquivosPatologia = (patologia, event) => {
    const input = event.target;
    this.enviarArquivosDaPatologia(patologia, input?.files || []).finally(() => {
      if (input) {
        input.value = "";
      }
    });
  };

  baixarArquivoPatologia = async (arquivo, patologiaId) => {
    const hashDownload = arquivo?.HashDownload || arquivo?.hashDownload;
    const nomeArquivo = arquivo?.NomeArquivo || arquivo?.nomeArquivo || "arquivo";
    const patologiaIdNumero = parseInt(patologiaId, 10);

    if (!hashDownload || Number.isNaN(patologiaIdNumero)) {
      alert("Arquivo sem dados de download.");
      return;
    }

    try {
      const resposta = await axios.get(`${REACT_APP_API}DownloadArquivo/arquivo`, {
        params: {
          patologiaId: patologiaIdNumero,
          hashDownload,
          nomeArquivo,
        },
        responseType: "blob",
      });

      const blobUrl = window.URL.createObjectURL(resposta.data);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = nomeArquivo;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      alert("Não foi possível baixar o arquivo.");
    }
  };

  removerArquivoRegistrado = async (id) => {
    if (!window.confirm("Remover arquivo?")) {
      return;
    }

    this.setState({ exibeCarregamento: true });

    try {
      const oportunidadeId = this.getOportunidadeId();
      await removerArquivo(oportunidadeId, id);
      const listaArquivos = await listarArquivos(oportunidadeId);
      this.setState({ listaArquivos });
    } catch (error) {
      alert("Erro ao remover arquivo.");
    } finally {
      this.setState({ exibeCarregamento: false });
    }
  };

  calcularNivelOportunidade = () => {
    const {
      oportunidade,
      configuracao,
      QtdeVidasPSPJ,
      QtdeVidasSocios,
      possuiPatologias,
      possuiAgregados,
    } = this.state;

    const totalTit = oportunidade?.QtdeVidasTit || 0;

    if (!totalTit) {
      return 1;
    }

    const percPSPJ = (QtdeVidasPSPJ / totalTit) * 100;
    const percSocios = (QtdeVidasSocios / totalTit) * 100;

    if (
      possuiPatologias ||
      possuiAgregados ||
      percPSPJ > (configuracao?.PercentualMaxPSPJ || 0) ||
      percSocios > (configuracao?.PercentualMaxSocios || 0)
    ) {
      return 3;
    }

    return 2;
  };

  salvarEContinuar = async () => {
    const {
      oportunidade,
      QtdeVidasCLT,
      QtdeVidasPSPJ,
      QtdeVidasSocios,
      possuiPatologias,
      possuiInativos,
      possuiAgregados,
      reembolsoDiferenciado,
      listaPatologiasRegistradas,
    } = this.state;

    const soma = QtdeVidasCLT + QtdeVidasPSPJ + QtdeVidasSocios;
    const totalTit = oportunidade?.QtdeVidasTit || 0;

    if (
      QtdeVidasCLT < 0 ||
      QtdeVidasPSPJ < 0 ||
      QtdeVidasSocios < 0 ||
      QtdeVidasCLT > totalTit ||
      QtdeVidasPSPJ > totalTit ||
      QtdeVidasSocios > totalTit
    ) {
      alert(`Cada campo de distribuição deve ficar entre 0 e ${totalTit} vidas.`);
      return;
    }

    if (soma !== totalTit) {
      alert("Distribua as vidas antes de continuar.");
      return;
    }

    if (possuiPatologias && (!listaPatologiasRegistradas || !listaPatologiasRegistradas.length)) {
      alert("Cadastre ao menos uma patologia para continuar.");
      return;
    }

    if (possuiPatologias) {
      const totalPatologias = this.getTotalVidasPatologias(listaPatologiasRegistradas);
      const limiteVidasPatologias = this.getLimiteVidasPatologias();

      if (totalPatologias > limiteVidasPatologias) {
        alert(
          `A soma de vidas em patologias (${totalPatologias}) não pode ultrapassar o total de vidas da oportunidade (${limiteVidasPatologias}).`
        );
        return;
      }

      const possuiPatologiaSemAnexo = listaPatologiasRegistradas.some(
        (patologia) => !this.getArquivosDaPatologia(patologia).length
      );

      if (possuiPatologiaSemAnexo) {
        alert("Cada patologia cadastrada deve ter pelo menos um relatório médico anexado.");
        return;
      }
    }

    this.setState({ exibeCarregamento: true });

    try {
      const oportunidadeDTO = {
        ...oportunidade,
        QtdeVidasCLT,
        QtdeVidasPSPJ,
        QtdeVidasSocios,
        QtdVidasCLT: QtdeVidasCLT,
        QtdVidasPSPJ: QtdeVidasPSPJ,
        QtdVidasSocios: QtdeVidasSocios,
        PossuiPatologias: possuiPatologias,
        PossuiInativos: possuiInativos,
        PossuiAgregados: possuiAgregados,
        ReembolsoDiferenciado: reembolsoDiferenciado,
        NivelOportunidade: this.calcularNivelOportunidade(),
      };

      await atualizarOportunidadeNivel2(
        oportunidadeDTO,
        retornarCookie("IdAgenteVenda"),
        retornarCookie("CdAgenteVendas")
      );

      const oportunidadeId = this.getOportunidadeId();
      const redirectTo = base64_encode("NavigationBar,ElegibilidadePage");
      const auth = `&Auth=${base64_encode(retornarCookie("Auth"))}`;
      const params = `&OportunidadeID=${oportunidadeId}`;

      document.location.href = `${REACT_APP_URL_INSTANCE}${redirectTo}${auth}${params}`;
    } catch (error) {
      alert("Não foi possível salvar as informações do Nível 2.");
      this.setState({ exibeCarregamento: false });
    }
  };

  voltar = () => {
    const oportunidadeId = this.getOportunidadeId();
    const redirectTo = base64_encode("NavigationBar,DadosEmpresaPage");
    const auth = `&Auth=${base64_encode(retornarCookie("Auth"))}`;
    const params = `&OportunidadeID=${oportunidadeId}`;

    document.location.href = `${REACT_APP_URL_INSTANCE}${redirectTo}${auth}${params}`;
  };

  render() {
    const {
      oportunidade,
      QtdeVidasCLT,
      QtdeVidasPSPJ,
      QtdeVidasSocios,
      erroDistribuicao,
      possuiPatologias,
      listaPatologiasCRM,
      listaPatologiasRegistradas,
      novaPatologiaId,
      novaPatologiaQtdeVidas,
      erroPatologia,
      possuiInativos,
      listaInativos,
      novoInativoTipoArtigo,
      novoInativoDataNascimento,
      novoInativoDataDesligamento,
      novoInativoElegibilidadeId,
      erroInativo,
      listaElegibilidades,
      possuiAgregados,
      listaAgregados,
      listaTiposVinculoAgregado,
      novoAgregadoTipoVinculo,
      novoAgregadoDataNascimento,
      novoAgregadoElegibilidadeId,
      erroAgregado,
      reembolsoDiferenciado,
      erroArquivo,
    } = this.state;

    const totalTitulares = oportunidade?.QtdeVidasTit || 0;
    const totalDistribuido = QtdeVidasCLT + QtdeVidasPSPJ + QtdeVidasSocios;
    const totalPatologias = this.getTotalVidasPatologias(listaPatologiasRegistradas);
    const limiteVidasPatologias = this.getLimiteVidasPatologias();
    const vidasPatologiasRestantes = Math.max(limiteVidasPatologias - totalPatologias, 0);

    return (
      <div className="fade-in">
        {this.state.exibeCarregamento && <Loader />}

        <div className="row container">
          <div className="col s9 m9 l9">
            <br />
            <b>
              <h5>Nova Oportunidade</h5>
            </b>
          </div>
          <div className="col s3 m3 l3">
            <br />
            <StepCounter step="2" total={this.getStepTotal().toString()} />
          </div>
        </div>

        <div className="row container">
          <HeaderPage
            Spotlight="Informações"
            Title="Adicionais"
            Description="Para empresas de 30 a 99 vidas, preencha os dados complementares abaixo."
          />

          <div className="col s8 m8 l8">
            <div className="nivel2-section">
              <h5 className="nivel2-section-title">A. Distribuição de vidas</h5>
              <p>Distribua as {totalTitulares} vidas titulares entre os vínculos abaixo.</p>

              <div className="row">
                <div className="input-field col s4">
                  <label className="active">Vidas CLT</label>
                  <input
                    type="number"
                    name="QtdeVidasCLT"
                    min={0}
                    max={totalTitulares}
                    step={1}
                    value={QtdeVidasCLT}
                    onChange={this.handleChangeDistribuicao}
                  />
                </div>
                <div className="input-field col s4">
                  <label className="active">Vidas PSPJ</label>
                  <input
                    type="number"
                    name="QtdeVidasPSPJ"
                    min={0}
                    max={totalTitulares}
                    step={1}
                    value={QtdeVidasPSPJ}
                    onChange={this.handleChangeDistribuicao}
                  />
                </div>
                <div className="input-field col s4">
                  <label className="active">Vidas Sócios</label>
                  <input
                    type="number"
                    name="QtdeVidasSocios"
                    min={0}
                    max={totalTitulares}
                    step={1}
                    value={QtdeVidasSocios}
                    onChange={this.handleChangeDistribuicao}
                  />
                </div>
              </div>

              <p className="nivel2-counter">
                Distribuído: {totalDistribuido} / {totalTitulares}
              </p>
              {erroDistribuicao && <p className="nivel2-error-msg">{erroDistribuicao}</p>}
            </div>

            <div className="nivel2-section">
              <h5 className="nivel2-section-title">B. Patologias</h5>
              <p>
                <label>
                  <input
                    type="checkbox"
                    checked={possuiPatologias}
                    onChange={this.togglePossuiPatologias}
                  />
                  <span>
                    Possui beneficiários afastados por doença ou com patologias crônicas?
                  </span>
                </label>
              </p>

              {possuiPatologias && (
                <>
                  <div className="nivel2-badge-nivel3">
                    Atenção: a presença de patologias direciona para análise (Nível 3).
                  </div>
                  <div className="row">
                    <div className="input-field col s6">
                      <select
                        className="browser-default"
                        value={novaPatologiaId}
                        onChange={(e) => this.setState({ novaPatologiaId: e.target.value })}
                      >
                        <option value="">Selecione a patologia</option>
                        {listaPatologiasCRM.map((p) => (
                          <option key={p.PatologiaId || p.patologiaId} value={p.PatologiaId || p.patologiaId}>
                            {p.Nome || p.nome}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="input-field col s3">
                      <label className="active">Qtde vidas</label>
                      <input
                        type="number"
                        min={1}
                        max={vidasPatologiasRestantes}
                        value={novaPatologiaQtdeVidas}
                        onChange={(e) => this.setState({ novaPatologiaQtdeVidas: e.target.value })}
                      />
                    </div>
                    <div className="input-field col s3">
                      <button type="button" className="OmintButton" onClick={this.adicionarNovaPatologia}>
                        Adicionar
                      </button>
                    </div>
                  </div>
                  <p className="nivel2-counter">
                    Patologias: {totalPatologias} / {limiteVidasPatologias}
                  </p>
                  {erroPatologia && <p className="nivel2-error-msg">{erroPatologia}</p>}

                  <table className="nivel2-table">
                    <thead>
                      <tr>
                        <th className="nivel2-col-patologia">Patologia</th>
                        <th className="nivel2-col-qtdevidas">Qtde vidas</th>
                        <th className="nivel2-col-anexos">Relatórios médicos</th>
                        <th className="nivel2-col-acoes">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      {listaPatologiasRegistradas.map((item) => {
                        const arquivosPatologia = this.getArquivosDaPatologia(item);
                        return (
                        <tr key={item.Id || item.id}>
                          <td className="nivel2-col-patologia">
                            <span
                              className="nivel2-text-ellipsis"
                              title={item.PatologiaNome || item.patologiaNome}
                            >
                              {item.PatologiaNome || item.patologiaNome}
                            </span>
                          </td>
                          <td className="nivel2-col-qtdevidas">{item.QtdeVidas || item.qtdeVidas}</td>
                          <td className="nivel2-col-anexos">
                            <div className="nivel2-anexos-wrapper">
                              {arquivosPatologia.length ? (
                                <table className="nivel2-anexos-subtable">
                                  <tbody>
                                    {arquivosPatologia.map((arquivo) => {
                                      const nomeArquivo = arquivo.NomeArquivo || arquivo.nomeArquivo;
                                      const hashDownload = arquivo.HashDownload || arquivo.hashDownload;
                                      const arquivoId = arquivo.Id || arquivo.id;
                                      const patologiaId = item.Id || item.id;
                                      return (
                                        <tr key={arquivoId}>
                                          <td>
                                            {hashDownload ? (
                                              <button
                                                type="button"
                                                className="nivel2-icon-btn"
                                                title={nomeArquivo}
                                                aria-label={`Baixar ${nomeArquivo}`}
                                                onClick={() => this.baixarArquivoPatologia(arquivo, patologiaId)}
                                              >
                                                <MaterialIcon icon="file_download" color="#172972" size={16} />
                                              </button>
                                            ) : (
                                              <span className="nivel2-icon-link" title={nomeArquivo}>
                                                <MaterialIcon icon="attach_file" color="#666" size={16} />
                                              </span>
                                            )}
                                          </td>
                                          <td>
                                            <button
                                              type="button"
                                              className="nivel2-icon-btn nivel2-icon-btn--danger"
                                              title={`Remover ${nomeArquivo}`}
                                              aria-label={`Remover ${nomeArquivo}`}
                                              onClick={() => this.removerArquivoRegistrado(arquivoId)}
                                            >
                                              <MaterialIcon icon="delete" color="#b00020" size={16} />
                                            </button>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              ) : (
                                <span className="nivel2-no-anexo">—</span>
                              )}
                            </div>
                            <input
                              type="file"
                              multiple
                              accept=".pdf,.png,.jpg,.jpeg"
                              style={{ display: "none" }}
                              ref={(el) => {
                                this.patologiaFileInputRefs[String(item.Id || item.id)] = el;
                              }}
                              onChange={(event) => this.handleChangeArquivosPatologia(item, event)}
                            />
                            <button
                              type="button"
                              className="nivel2-icon-btn nivel2-icon-btn--add"
                              title="Clique para abrir o seletor de arquivos e adicionar anexos"
                              aria-label="Adicionar anexo"
                              onClick={() => this.abrirSeletorArquivosPatologia(item.Id || item.id)}
                            >
                              <MaterialIcon icon="attach_file" color="#172972" size={16} />
                            </button>
                          </td>
                          <td className="nivel2-col-acoes">
                            <button
                              type="button"
                              className="nivel2-icon-btn nivel2-icon-btn--danger"
                              title="Remover patologia"
                              aria-label="Remover patologia"
                              onClick={() => this.removerPatologiaRegistrada(item.Id || item.id)}
                            >
                              <MaterialIcon icon="delete_forever" color="#b00020" size={22} />
                            </button>
                          </td>
                        </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  {erroArquivo && <p className="nivel2-error-msg">{erroArquivo}</p>}
                </>
              )}
            </div>

            <div className="nivel2-section">
              <h5 className="nivel2-section-title">C. Reembolso diferenciado</h5>
              <p>
                <label>
                  <input
                    type="checkbox"
                    checked={reembolsoDiferenciado}
                    onChange={(e) => this.setState({ reembolsoDiferenciado: e.target.checked })}
                  />
                  <span>Deseja personalizar reembolso por plano após as elegibilidades?</span>
                </label>
              </p>
            </div>

            <div className="row">
              <div className="col s6">
                <button type="button" className="OmintButton" onClick={this.voltar}>
                  Voltar
                </button>
              </div>
              <div className="col s6 right-align">
                <button type="button" className="OmintButton" onClick={this.salvarEContinuar}>
                  Salvar e Continuar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
